import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractDynamic from "../Dynamic";

class Dynamic extends AbstractDynamic {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-dynamic-documents-ipr';
  }
}

export default Dynamic;
